"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateVoiceoverPreviewRequestToJSON = exports.GenerateVoiceoverPreviewRequestFromJSONTyped = exports.GenerateVoiceoverPreviewRequestFromJSON = exports.instanceOfGenerateVoiceoverPreviewRequest = void 0;
var runtime_1 = require("../runtime");
var AssetError_1 = require("./AssetError");
var VoiceType_1 = require("./VoiceType");
var VoiceoverTone_1 = require("./VoiceoverTone");
/**
 * Check if a given object implements the GenerateVoiceoverPreviewRequest interface.
 */
function instanceOfGenerateVoiceoverPreviewRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGenerateVoiceoverPreviewRequest = instanceOfGenerateVoiceoverPreviewRequest;
function GenerateVoiceoverPreviewRequestFromJSON(json) {
    return GenerateVoiceoverPreviewRequestFromJSONTyped(json, false);
}
exports.GenerateVoiceoverPreviewRequestFromJSON = GenerateVoiceoverPreviewRequestFromJSON;
function GenerateVoiceoverPreviewRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
        'transcript': !(0, runtime_1.exists)(json, 'transcript') ? undefined : json['transcript'],
        'instructions': !(0, runtime_1.exists)(json, 'instructions') ? undefined : json['instructions'],
        'voiceType': !(0, runtime_1.exists)(json, 'voice_type') ? undefined : (0, VoiceType_1.VoiceTypeFromJSON)(json['voice_type']),
        'language': !(0, runtime_1.exists)(json, 'language') ? undefined : json['language'],
        'voiceProfileId': !(0, runtime_1.exists)(json, 'voice_profile_id') ? undefined : json['voice_profile_id'],
        'isAiVoiceover': !(0, runtime_1.exists)(json, 'is_ai_voiceover') ? undefined : json['is_ai_voiceover'],
        'aiVoiceoverTone': !(0, runtime_1.exists)(json, 'ai_voiceover_tone') ? undefined : (0, VoiceoverTone_1.VoiceoverToneFromJSON)(json['ai_voiceover_tone']),
        'voiceoverSystem': !(0, runtime_1.exists)(json, 'voiceover_system') ? undefined : json['voiceover_system'],
        'rejectionReason': !(0, runtime_1.exists)(json, 'rejection_reason') ? undefined : json['rejection_reason'],
        'assetError': !(0, runtime_1.exists)(json, 'asset_error') ? undefined : (0, AssetError_1.AssetErrorFromJSON)(json['asset_error']),
        'generatedScriptId': !(0, runtime_1.exists)(json, 'generated_script_id') ? undefined : json['generated_script_id'],
    };
}
exports.GenerateVoiceoverPreviewRequestFromJSONTyped = GenerateVoiceoverPreviewRequestFromJSONTyped;
function GenerateVoiceoverPreviewRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'url': value.url,
        'transcript': value.transcript,
        'instructions': value.instructions,
        'voice_type': (0, VoiceType_1.VoiceTypeToJSON)(value.voiceType),
        'language': value.language,
        'voice_profile_id': value.voiceProfileId,
        'is_ai_voiceover': value.isAiVoiceover,
        'ai_voiceover_tone': (0, VoiceoverTone_1.VoiceoverToneToJSON)(value.aiVoiceoverTone),
        'voiceover_system': value.voiceoverSystem,
        'rejection_reason': value.rejectionReason,
        'asset_error': (0, AssetError_1.AssetErrorToJSON)(value.assetError),
        'generated_script_id': value.generatedScriptId,
    };
}
exports.GenerateVoiceoverPreviewRequestToJSON = GenerateVoiceoverPreviewRequestToJSON;
